"use client";

import React from "react";
import Image from "next/image";
import "./index.css";
import { Box } from "@mui/material";

interface SliderProps {
  url: any;
  title: any;
}

export const Slider: React.FC<SliderProps> = ({ url, title }) => {
  return (
    <Box
      className="slider-container"
      sx={{
        display: "inline-block",
        justifyContent: "center",
        alignItems: "center",
        padding: "0.5rem 1rem",
        textAlign: "center !important",
        width: "100%",
        "&:hover": {
          backgroundColor: "none",
          cursor: "pointer",
        },
      }}
    >
      <div
        style={{
          minWidth: "55px",
          textAlign: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          margin: "auto",
        }}
      >
        <Image
          src={url}
          alt="icon"
          height={500}
          width={500}
          style={{ objectFit: "cover" }}
        />
      </div>
      <p>{title}</p>
    </Box>
  );
};

export default Slider;
